import PlayButtonFile from "../../statics/svg/play.svg";
import React from "react";

export interface PlayButtonProps {
  onClick: () => void;
}

const PlayButton = ({ onClick }: PlayButtonProps) => {
  return (
    <div className="PlayButton">
      <button type="button" onClick={onClick}>
        <img src={PlayButtonFile} alt="Play Button" />
      </button>
    </div>
  );
};

export default PlayButton;
